// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type FastTimer20FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const FastTimer20Filled: FC<FastTimer20FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M12.749 16c-1.666 0-3.082-.583-4.249-1.75-1.167-1.167-1.75-2.583-1.75-4.249 0-1.653.583-3.067 1.75-4.24C9.667 4.586 11.083 4 12.749 4c1.653 0 3.067.587 4.24 1.76 1.174 1.174 1.761 2.588 1.761 4.241 0 1.666-.587 3.082-1.76 4.249-1.174 1.167-2.588 1.75-4.241 1.75Zm1.71-3.208 1.062-1.063-2.023-2.027V7H12v3.318l2.458 2.474ZM2.5 7.5V6h3v1.5h-3Zm-1 3.25v-1.5h4v1.5h-4Zm1 3.25v-1.5h3V14h-3Z" />
        </svg>
    );
};

export default FastTimer20Filled;
